import React from 'react';
import { PaginationState, calculatePageRange } from '.';
import { range } from 'lodash-es';
import { Button, ButtonGroup } from '@ygtechnologies/rubus-ui';
import { faChevronLeft, faChevronRight, faChevronsLeft, faChevronsRight } from '@fortawesome/pro-light-svg-icons';
import theme from './Pagination.module.scss';

interface PaginationProps {
    value: PaginationState;
    showFirstLastButtons?: boolean;
    showPreviousNextButtons?: boolean;
    pagesToDisplay?: number;
}

const Pagination: React.FC<PaginationProps> = ({ value, pagesToDisplay = 7 }) => {
    const pageRange = calculatePageRange(value.currentPage, value.numberOfPages, pagesToDisplay);
    const pages = range(pageRange.start, pageRange.end + 1);

    const isFirstPage = value.currentPage === 0;
    const isLastPage = value.currentPage >= value.numberOfPages - 1;

    return (
        <div className={theme.pagination}>
            <div className={theme.info}>
                Showing{' '}
                <strong>
                    {value.displayedEntries.start + 1} to {Math.min(value.displayedEntries.end + 1, value.totalEntries)} of{' '}
                    {value.totalEntries}
                </strong>{' '}
                entries
            </div>

            <ButtonGroup aria-label="Pagination">
                <Button
                    variant="tertiary"
                    className={theme.pageButton}
                    size="xs"
                    icon={faChevronsLeft}
                    disabled={isFirstPage}
                    onClick={() => value.setPage(0)}
                    title="First page"
                />
                <Button
                    variant="tertiary"
                    className={theme.pageButton}
                    size="xs"
                    icon={faChevronLeft}
                    disabled={isFirstPage}
                    onClick={() => value.setPage(value.currentPage - 1)}
                    title="Previous page"
                />
                {pages.map((i) => (
                    <Button
                        key={i}
                        variant={i === value.currentPage ? 'primary' : 'tertiary'}
                        className={theme.pageButton}
                        size="xs"
                       
                        onClick={() => value.setPage(i)}>
                        {i + 1}
                    </Button>
                ))}
                <Button
                    variant="tertiary"
                    className={theme.pageButton}
                    size="xs"
                    icon={faChevronRight}
                    disabled={isLastPage}
                    onClick={() => value.setPage(value.currentPage + 1)}
                    title="Next page"
                />
                <Button
                    variant="tertiary"
                    className={theme.pageButton}
                    size="xs"
                    icon={faChevronsRight}
                    disabled={isLastPage}
                    onClick={() => value.setPage(value.numberOfPages - 1)}
                    title="Last page"
                />
            </ButtonGroup>
        </div>
    );
};

export default Pagination;
